import { W as WuiInputMenu$1, d as defineCustomElement$1 } from './p-Ei9uyGAs.js';

const WuiInputMenu = WuiInputMenu$1;
const defineCustomElement = defineCustomElement$1;

export { WuiInputMenu, defineCustomElement };
